export default "__VITE_ASSET__CKslVIJJ__"